// React
import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

// Appt
import Anchor from '../../components/simple/anchor/Anchor.js'
import Box from '../../components/simple/box/Box.js'
import CheckBox from '../../components/simple/input/CheckBox.js'
import Form from '../../components/simple/form/Form.js'
import FormField from '../../components/simple/formField/FormField.js'
import Text from '../../components/simple/text/Text.js'
import TextInput from '../../components/simple/input/TextInput.js'
import Image from '../../components/simple/image/Image.js'

// Services
import NotificationService from '../../services/NotificationService'
import UserService from '../../services/UserService'

import queryStringHandler from '../../utils/queryStringHandler'
import ActionButton from '../../components/compound/actionButton/ActionButton.js'
import Meter from '../../components/simple/meter/Meter.js'

import zxcvbn from 'zxcvbn'


/**
 * `UserActivate` renders a User activation screen
 */
function UserActivate (props) {
  const navigate = useNavigate()
  const location = useLocation()
  const queryStringVal = queryStringHandler(location.search)

  const inviteToken = queryStringVal.token

  const [activateValues, setActivateValues] = useState({
    firstname: '',
    lastname: '',
    password: '',
    type: 'new',
    tandc: false
  })

  const [password, setPassword] = useState('')
  const [strength, setStrength] = useState(null)

  const strengthLimit = {
    0: 'Insecure',
    1: 'Weak',
    2: 'Average',
    3: 'Good',
    4: 'Strong'
  }

  const strengthColor = {
    0: 'red',
    1: 'orangered',
    2: 'orange',
    3: 'yellowgreen',
    4: 'green'
  }

  const onChange = (nextValue) => {
    setActivateValues(nextValue)
    handlePasswordChanged(nextValue.password)
  }

  const onSubmit = async () => {
    if (!activateValues.tandc) {
      NotificationService.error('You must accept the terms and conditions to continue.')
    } else {
      var activateStatus = await UserService.acceptInvite(inviteToken, activateValues)

      // stop if the activation failed
      if (activateStatus?.error) {
        NotificationService.error(activateStatus.error)
      } else {
        NotificationService.success('Your account has been activated. Please login to continue.')
        navigate('/login')
      }
    }
  }


  const onTandCChange = () => {
    return null
  }

  const termsUrl = 'https://www.behavioursmart.co.uk/terms-conditions'
  const privacyUrl = 'https://www.behavioursmart.co.uk/privacy-policy'


  const getPasswordStrength = (password) => {
    if (password?.length) {

      let strength = zxcvbn(password).score

      if (password.length < 8) { 
        strength = 0
      }

      if (password.length < 10) { 
        strength = 1
      }

     return strength
    }
    return 0
  }

    const handlePasswordChanged = (pwd) => {
      setPassword(pwd)
      
      let strength = getPasswordStrength(pwd)
      setStrength(strength)
    }

  return (
    <Box align='center' height='100%' justify='center'>
      <Box width='small' alignSelf='center' height='xsmall' margin={{ bottom: 'none' }}>
        <Image fit='contain' src={'/besmart-logo-white.png?r=001'} />
      </Box>
      <Box align='center' animation='fadeIn' pad='large' alignSelf='center' width='medium'>
        <Box>
          <Text color='white' margin={{ top: 'none', bottom: 'xsmall' }} textAlign='start' weight='bold'>You have been invited to join the BehaviourSmart app.</Text>
        </Box>

        <Box>
          <Text color='white' margin={{ top: 'none', bottom: 'small' }} size='small' textAlign='start'>To accept the invitation and create your account, enter your name and a chosen password below.</Text>
        </Box>

        <Box width='medium' border={{ color: 'brand', side: 'top' }} margin={{ top: 'small' }} pad={{ top: 'small' }}>
          <Form
            value={activateValues}
            onChange={(nextValue) => onChange(nextValue)}
            onSubmit={() => onSubmit()}
          >
            <FormField color='white' label={<Text size='medium' color='white'>First Name</Text>} name='firstname' required>
              <TextInput name='firstname' type='text' />
            </FormField>

            <FormField color='white' label={<Text size='medium' color='white'>Last Name</Text>} name='lastname' required>
              <TextInput name='lastname' type='text' />
            </FormField>

            <FormField color='white' label={<Text size='medium' color='white'>Password</Text>} name='password' required>
               <Text color='white' size='medium'>Your password should be at least 10 characters long and include a mix of upper and lower case letters, numbers, and special characters.</Text>
            
              <FormField margin={{ vertical: 'small' }} name='password' required>
                <TextInput name={'password'} placeholder='Enter password' type='password' />
              </FormField>
        {strength !== null &&
                <Meter background='light-2' max={5} size='full' thickness='xsmall' type='bar' values={[{ color: strengthColor[strength], value: strength + 1 }]} />}
                {strength !== null ? <Text color={strengthColor[strength]}>{strengthLimit[strength]}</Text> : ''}

              
        
            </FormField>

            
           
            <FormField name='tandc'>
              <CheckBox color='white' label={<Text color='white' size='small'>I accept the <Anchor color='white' onClick={() => window.open(termsUrl, '_blank')} size='small' label='Terms & Conditions' /> and <Anchor onClick={() => window.open(privacyUrl, '_blank')} size='small' color='white' label='Privacy Policy' /></Text>} name='tandc' onChange={onTandCChange} />
            </FormField>


              {password.length > 0 && strength < 2 && <Text color='orange' size='small'>Your password is not strong enough. Please choose a stronger password.</Text>}
      
              {password.length > 0 && strength >= 2 && activateValues.tandc && 
                <ActionButton fill='horizontal' label='Accept the invitation' primary type='submit' />
              }

          </Form>
        </Box>
      </Box>
    </Box>
  )
}

export default UserActivate
